export const initSizes = [
    { size_name: "sss", chest: "", long: "", quantity: "" },
    { size_name: "ss", chest: "", long: "", quantity: "" },
    { size_name: "s", chest: "", long: "", quantity: "" },
    { size_name: "m", chest: "", long: "", quantity: "" },
    { size_name: "l", chest: "", long: "", quantity: "" },
    { size_name: "xl", chest: "", long: "", quantity: "" },
];
  
export const initExtraSizes = ["ssss", "2xl", "3xl", "4xl", "5xl", "6xl", "7xl", "8xl", "9xl", "10xl"];

export const initAllSizes = ["ssss", "sss", "ss", "s", "m", "l", "xl", "2xl", "3xl", "4xl", "5xl", "6xl", "7xl", "8xl", "9xl", "10xl"];
